import { withStyles } from '@material-ui/core';

import CarListPage from './component';
import styles from './styles';

export default withStyles(styles)(CarListPage);
